<template>
  <v-row>
    <v-col md="12">
      <v-row>
        <v-col md="6">
          <h3>Internaciones</h3>
        </v-col>
        <v-col md="6" class="text-right">
          <v-btn @click="impresion = true" color="primary" fab dark>
            <v-icon>mdi-printer</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col md="12">
      <lista
        :items="ListaPorArea"
        v-if="!selected"
        tomar
        v-model="selected"
      ></lista>
    </v-col>
    <v-col md="12" v-if="!selected">
      <v-pagination
        v-model="pagina"
        :length="Paginas"
        :total-visible="15"
      ></v-pagination>
    </v-col>
    <v-col md="12">
      <h3 class="green--text" v-if="selected">
        Al estar pendiente se puede modificar
      </h3>
      
      <Modificar
        v-if="selected"
        :idsolic="selected.id_solic"
        @guardado="guardado()"
      ></Modificar>
    </v-col>
    <v-dialog v-model="impresion" hide-overlay persistent width="80vw">
      <v-card color="headeryfooter" height="80vh">
        <v-system-bar color="headeryfooter darken-2" dark>
          <v-spacer></v-spacer>
          <v-icon @click="impresion = false">mdi-close</v-icon>
        </v-system-bar>
        <v-card-text>
          <div class="resp-container">
            <iframe
              class="resp-iframe"
              :src="urlReporte"
              allowfullscreen
            ></iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Modificar from '@/components/Practica/Modificar'
import usuario from '@/components/Usuarios/TraerNombre'
import lista from '@/components/Practica/Lista'
import { isMobile, isAndroid, isWinPhone, isIOS } from 'mobile-device-detect'
export default {
  components: {
    Modificar,
    usuario,
    lista,
  },
  props: ['id_afiliado'],
  created() {
    if (this.sinmanejador[3]) {
      this.setManejador(3)
      this.$msjpusher.$on('practica-tomada', this.practicatomada)
      this.$msjpusher.$on('practica-guardada', this.practicaguardada)
    }
  },
  destroyed() {
    // this.$msjpusher.$on("practica-tomada", this.practicatomada);
    // this.$msjpusher.$on("practica-guardada", this.practicaguardada);

    this.$msjpusher.$on('practica-tomada', (datos) => {})
    this.$msjpusher.$on('practica-guardada', (datos) => {})
  },
  data() {
    return {
      pagina: 1,
      selected: undefined,
      impresion: false,
    }
  },
  computed: {
    ...mapState('comun', ['sinmanejador', 'bandejaactual']),
    ...mapState('autorizaciones', ['ListaPorArea', 'Paginas', 'Filtros']),
    ...mapState('areas', { listaareas: 'Lista' }),
    esMobile() {
      return isMobile || isAndroid || isWinPhone || isIOS
    },
    urlReporte() {
      let ret = ''
      if (this.esMobile) {
        ret = `https://oseiv.ddns.net/Reportes/Default.aspx?rpt=ObraSocial_Afiliaciones_V/internaciones&pdf=1&rs:embed=true`
      } else {
        ret = `https://oseiv.ddns.net/Reportes/Default.aspx?rpt=ObraSocial_Afiliaciones_V/internaciones&rs:embed=true`
      }
      return ret
    },
  },
  methods: {
    ...mapActions('autorizaciones', ['traerPorAreaPaginado', 'resetFiltros']),
    ...mapActions('comun', ['setBandeja', 'setManejador']),
    practicatomada(datos) {
      let autoriz = this.ListaPorArea.find((x) => x.id_solic === datos.id_solic)
      if (autoriz) {
        autoriz.TomadaPor = datos.id_user
      }
    },
    practicaguardada(datos) {
      if (datos.id_area == 3 && this.bandejaactual == 3) {
        this.traerPorAreaPaginado({ id_area: 3, pagina: this.pagina })
      }
      // else {
      //   let autoriz = this.ListaPorArea.find(
      //     (x) => x.id_solic === datos.id_solic
      //   );
      //   if (autoriz) {
      //     this.traerPorArea(2);
      //   }
      // }
    },
    guardado() {
      this.selected = undefined
      this.traerPorAreaPaginado({ id_area: 3, pagina: this.pagina })
    },
    getColor(id_estado) {
      let ret = 'lime lighten-4'
      switch (id_estado) {
        case 1:
          ret = 'red'
          break
        case 2:
          ret = 'green'
          break
        case 3:
          ret = 'blue'
          break
        case 4:
          ret = 'black'
          break
        case 5:
          ret = 'white'
          break
        default:
          break
      }
      return ret
    },
  },
  watch: {
    pagina() {
      this.traerPorAreaPaginado({ id_area: 3, pagina: this.pagina })
    },
    Filtros() {
      this.pagina = 1
      this.traerPorAreaPaginado({ id_area: 3, pagina: 1 })
    }
  },
  mounted() {
    this.setBandeja(3)
    this.traerPorAreaPaginado({ id_area: 3, pagina: this.pagina })
    this.resetFiltros()
  },
}
</script>
